<div class="flex flex-col gap-4 mb-6">
  <p class="text-surface-600 dark:text-surface-400">{{ 'hotkeys.shortcut-record-hint' | translate }}</p>
  <div>
    <label for="shortcut-input" class="block mb-2 text-sm font-medium">{{ 'hotkeys.shortcut-combo' | translate }}</label>
    <app-shortcut-input
      [combos]="filteredCurrentCombos()"
      [excludeButtonId]="buttonId()"
      [shortcutRegistry]="shortcutRegistry"
      [autofocus]="true"
      [shouldIncludeCombo]="platformComboFilter"
      inputId="shortcut-input"
      (combosChange)="onCombosChange($event)"
      (hasErrorChange)="hasError.set($event)"
      (hasContentChange)="hasContent.set($event)"
    />
  </div>
</div>

<ng-template phxDialogButtons>
  <div class="flex flex-row justify-end gap-2">
    @if (hasContent()) {
      <p-button
        severity="secondary"
        [label]="'hotkeys.clear-shortcut' | translate"
        (onClick)="clear()"
        [attr.data-testid]="'shortcut-dialog-clear'"
      />
    }
    <p-button
      severity="secondary"
      [label]="'common.cancel' | translate"
      (onClick)="cancel()"
      [attr.data-testid]="'shortcut-dialog-cancel'"
    />
    <p-button
      severity="primary"
      [label]="'common.save' | translate"
      (onClick)="save()"
      [disabled]="hasError()"
      [attr.data-testid]="'shortcut-dialog-save'"
    />
  </div>
</ng-template>
